import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";

import classes from'./PublishersInput.module.css';
import NewPublisher from "../NewPublisher/NewPublisher";
import apiUrl from "../../../shared/config";

class PublishersInput extends Component  {
    state = {
        publishers: [],
        selected_publishers: [],
        new_publisher: false
    };

    componentDidMount() {
        if (this.state.publishers !== []) {
            axios.get(apiUrl +'Publishers/getPublishers')
                .then(response => {
                    this.setState({publishers: response.data});
                });
        }
        this.setState({selected_publishers: this.props.gamePublishers});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({selected_publishers: this.props.gamePublishers});
        }
    }

    addPublisher = () => {
        this.setState(
            {selected_publishers: [
                    ...this.state.selected_publishers,
                    {
                        game_publisher_id: null
                    }]
            });
    };

    newPublisherToggle = () => {
        this.setState({new_publisher: !this.state.new_publisher});
    };

    newPublishersHandler = (new_publisher) => {
        this.setState({publishers: [new_publisher, ...this.state.publishers]});
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let publishers_input_element = null;
        if (this.state.publishers && this.state.publishers.length) {
            const publishersOptions = this.state.publishers
                .map( publisher => ({value: publisher.game_publisher_id, label: publisher.game_publisher_name}));

            if (this.state.selected_publishers && this.state.selected_publishers.length) {
                let publishers_index = 0;
                let selected_publishers = [...this.state.selected_publishers];
                publishers_input_element = (
                    <>
                        <dd className="col-sm-9">
                            {selected_publishers.map(publisher => {
                                let publishers_index_local = publishers_index;
                                const publisher_id = selected_publishers[publishers_index_local].game_publisher_id;
                                const default_index = this.arraySearch(publishersOptions, publisher_id);
                                let default_value = {label: "Add a publisher for this game."};
                                if (publisher_id !== null) {
                                    default_value = publishersOptions[default_index];
                                }
                                const publisher_jsx = (
                                    <div className={classes.PublishersBlock} key={publisher_id}>
                                        <Select
                                            className={classes.PublishersSelect}
                                            defaultValue={{
                                                value: selected_publishers[publishers_index_local].game_publisher_id,
                                                label: default_value.label,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={publishersOptions}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                let publishers_local = [...selected_publishers];
                                                publishers_local[publishers_index_local] = {
                                                    game_publisher_id: val.value
                                                };
                                                this.setState({selected_publishers: publishers_local});
                                                this.props.publishersUpdate(publishers_local);
                                            }}
                                        />
                                        <div className={classes.DeletePublishers}>
                                            <Button className={classes.DeletePublishersButton} size="sm" variant={"outline-danger"} onClick={() => {
                                                let filtered_array = selected_publishers.filter((value,index,array) => {
                                                    return index !== (publishers_index_local)
                                                });
                                                this.setState({selected_publishers: filtered_array});
                                                this.props.publishersUpdate(filtered_array);
                                            }}>X</Button>
                                        </div>
                                    </div>
                                );
                                publishers_index++;

                                return publisher_jsx;
                            })}
                        </dd>
                        <dt className="col-sm-3"> </dt>
                    </>
                );
            }
        }

        let new_publisher_jsx = '';
        if (this.state.new_publisher === true) {
            new_publisher_jsx = (<NewPublisher
                publishers={this.state.publishers}
                newPublisherToggle={this.newPublisherToggle}
                onNewPublisher={this.newPublishersHandler}
            />);
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Publishers</label></dt>
                {publishers_input_element}
                {new_publisher_jsx}
                <dd className="col-sm-6"><Button className="col-sm-12" variant="outline-primary" onClick={this.addPublisher} disabled={this.state.new_publisher}>Add Publisher to Game</Button></dd>
                <dd className="col-sm-3"><Button className="col-sm-12" variant="outline-secondary" onClick={this.newPublisherToggle} disabled={this.state.new_publisher}>Enter New Publisher</Button></dd>
            </dl>
        );
    }
}

export default PublishersInput;